import React from 'react';
import * as Mui  from '@mui/material';
import * as MuiIcon from '@mui/icons-material';
import './Page404.css';

const Page404 = (props) => {
  return (
      <Mui.Grid2 item xs={12} style={{margin:'20px'}} className="class404">
        <h1>404 - Page Not Found</h1>
        <p>Sorry, the page you are looking for could not be found.</p>
      </Mui.Grid2>
  );
}

export default Page404;



